import React from 'react';
import classes from './Loader.module.scss'
const Loader = () => (    
    //<div className={classes['lds-ellipsis']}><div></div><div></div><div></div><div></div></div>
    <div className={classes.loader}>Loading...</div>
);

export default Loader